import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import AdminPage from "./pages/AdminPage";
import GalleryPage from "./pages/GalleryPage";
import HomePage from "./pages/HomePage";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return <BrowserRouter><ScrollToTop /><Routes><Route path="/" element={<HomePage />} /><Route path="/galeri" element={<GalleryPage />} /><Route path="/admin" element={<AdminPage />} /></Routes><Toaster theme="dark" position="bottom-right" /></BrowserRouter>;
}
